module.exports = __webpack_public_path__ + "img/Voltage.15da905e.jpg";